import { React, useCallback, useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { FreeMode, Pagination, Navigation } from "swiper";
import { SVGIcons, ImgIcons, Imgbanner, getcolors } from "../../Helpers/Common";
import { Link } from "react-router-dom";
import { Showdetailspopup } from "../Showdetailspopup/Showdetailspopup";
import { Watchtrailer } from "../../components/vidjs/mainPlayer";
import Hover from "../OnHoverDetails/Hover";

var SVGIcon = "";
var ImageData = "";
ImgIcons().then((result) => (ImageData = result));
SVGIcons().then((resultData) => (SVGIcon = resultData));

export function Layout3(props) {
  const [showdetails, setshowdetails] = useState(false);
  const [details, setdetails] = useState(false);
  // const [player, setplayer] = useState(false);
  // const [showShimmer, setShowShimmer] = useState(true);

  // const handleTimeout = useCallback(() => {
  //   setShowShimmer(false);
  // }, []);

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setShowShimmer(false);
  //   }, 1000);

  //   return () => {
  //     clearTimeout(timer);
  //   };
  // }, [handleTimeout]);

  function showdetailspop(data) {
    setshowdetails(true);
    setdetails(data);
  }

  let Closepopup = () => {
    setshowdetails(false);
  };

  // function watchtrailer() {
  //   setplayer(true);
  // }
  // let closePlayer = () => {
  //   // setPlayer(false)
  //   var element = document.getElementById("LiveTVplayer");
  //   setplayer(false);
  //   // props.Closebtn();
  // };

  return (
    <>
      <section className="mb-0 dD-none">
        <div className="temp23">
          {/* {showShimmer ? (
            <div className="line linehead" />
          ) : (
            <>    </>
            )} */}
          <div className="head">
            <h3>
              {props.title.display_title}
              <span className="red">{props.title.display_title_sufix}</span>
            </h3>
            {props.title.show_more ? (
              <Link to={"baypage/" + props.title.slug}>
                {" "}
                <img src={SVGIcon["right-arrow.svg"]} />{" "}
              </Link>
            ) : null}
          </div>

          <div className="temp23-area">
            <Swiper
              slidesPerView={2.4}
              spaceBetween={16}
              freeMode={true}
              loop={false}
              // loopFillGroupWithBlank={true}
              centeredSlides={false}
              breakpoints={{
                700: {
                  slidesPerView: 3.9,
                },
                820: {
                  slidesPerView: 3.9,
                },
                850: {
                  slidesPerView: 6.3,
                },
              }}
              modules={[FreeMode, Pagination]}
              className="temp23-slider"
            >
              {props.Layout1.map((data, index) => {
                var bgcolors = getcolors;
                var random = Math.floor(Math.random() * bgcolors.length);
                if (data.content_bg_color) {
                  var bgcolor = { backgroundColor: bgcolors[random] };
                } else {
                  var bgcolor = { backgroundColor: bgcolors[random] };
                }
                if (data.content_keyword) {
                  var keyword = data.content_keyword.split(",");
                  keyword = keyword[0];
                }
                var premium = "";
                if (data.premium && !data.original_tag) {
                  var premium = (
                    <img
                      src={props.silverIcon}
                      style={{
                        width: "1.3rem",
                        marginRight: "3px",
                        marginBottom: "2px",
                      }}
                    />
                  );
                }
                if (data.original_tag && data.premium) {
                  var original = (
                    <img
                      src={props.goldenIcon}
                      style={{
                        width: "1.3rem",
                        marginRight: "3px",
                        marginBottom: "2px",
                      }}
                    />
                  );
                }
                return (
                  <SwiperSlide key={index} className="temp23-item">
                    {/* {showShimmer ? (
                      <img src={ImageData["placeholder1.png"]} alt="shimmer" className="shimmer" />
                    ) : (
                      <>       </>
                      )} */}
                    <a
                      onClick={() => {
                        showdetailspop(data);
                      }}
                    >
                      <div className="temp23-itemColor" style={bgcolor}>
                        <img src={data.thumbnail_image2.small} alt="DocuBay" />
                      </div>
                      <div className="bay-title">{keyword}</div>
                      <div className="premium-red">
                        {premium}
                        {original}
                      </div>
                    </a>

                  </SwiperSlide>
                );
              })}
              <SwiperSlide></SwiperSlide>
            </Swiper>
          </div>
        </div>
      </section>
      <section className="mb-0 dD-block">
        <div className="temp23">
          {/* {showShimmer ? (
            <div className="linedesk" />
          ) : (
            <>
                </>
          )} */}
          <div className="head-layout">
            <h3>
              {props.title.display_title}
              <span className="red">{props.title.display_title_sufix}</span>
            </h3>
            <div className="arrow-layout">
              {props.title.show_more ? (
                <Link to={"/baypage/" + props.title.slug}>
                  <div className="hoverText">View All</div>
                </Link>
              ) : null}
              <div className="arrow-icon">
                {props.title.show_more ? (
                  <Link to={"/baypage/" + props.title.slug}>
                    <img src={SVGIcon["right-arrow.svg"]} />
                  </Link>
                ) : null}
              </div>
            </div>
          </div>

          <div className="temp23-area">
            <div className="side-overlay-L dD-block"></div>
            <div className="side-overlay-R dD-block"></div>
            <Swiper
              navigation={{
                prevEl: ".slick-prev",
                nextEl: ".slick-next",
              }}
              slidesPerView={2.4}
              spaceBetween={16}
              freeMode={true}
              slidesPerGroup={5}
              loop={false}
              // loopFillGroupWithBlank={true}
              centeredSlides={false}
              breakpoints={{
                650: {
                  slidesPerView: 1,
                },
                850: {
                  slidesPerView: 6.3,
                },
              }}
              modules={[Navigation, FreeMode, Pagination]}
              className="temp23-slider"
            >
              <button
                className="slick-prev slick-arrow"
                type="button"
                aria-label="Previous"
              />
              {props.Layout1.map((data, index) => {
                var bgcolors = getcolors;
                var random = Math.floor(Math.random() * bgcolors.length);
                if (data.content_bg_color) {
                  var bgcolor = { backgroundColor: bgcolors[random] };
                } else {
                  var bgcolor = { backgroundColor: bgcolors[random] };
                }
                if (data.content_keyword) {
                  var keyword = data.content_keyword.split(",");
                  keyword = keyword[0];
                }
                var premium = "";
                if (data.premium && !data.original_tag) {
                  var premium = (
                    <img
                      src={props.silverIcon}
                      style={{
                        width: "1.7rem",
                        marginRight: "3px",
                        marginBottom: "2px",
                      }}
                    />
                  );
                }
                if (data.original_tag && data.premium) {
                  var original = (
                    <img
                      src={props.goldenIcon}
                      style={{
                        width: "1.7rem",
                        marginRight: "3px",
                        marginBottom: "2px",
                      }}
                    />
                  );
                }
                return (
                  <SwiperSlide key={index} className="temp23-item">
                    {/* {showShimmer ? (
                      <img src={ImageData["placeholder1.png"]} alt="shimmer" className="shimmer" />
                    ) : (
                      <>
                           </>
                    )} */}
                    <Hover
                      data={data}
                      silverIcon={props.silverIcon}
                      goldenIcon={props.goldenIcon}
                    />
                    <div className="temp23-itemColor" style={bgcolor}>
                      <img src={data.thumbnail_image2.small} alt="DocuBay" />
                    </div>
                    <div className="bay-title">{keyword}</div>
                    <div className="premium-red">
                      {premium}
                      {original}
                    </div>
                  </SwiperSlide>
                );
              })}
              <SwiperSlide></SwiperSlide>
              <button
                className="slick-next slick-arrow"
                type="button"
                aria-label="Next"
              />
            </Swiper>
          </div>
        </div>
      </section>
      {showdetails ? (
        <Showdetailspopup
          data={details}
          Closebtn={Closepopup}
          silverIcon={props.silverIcon}
          goldenIcon={props.goldenIcon}
        />
      ) : null}
    </>
  );
}

export default Layout3;
